<script>
import { authComputed } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from 'axios'
import moment from 'moment';

export default {
	components: {
		VuePerfectScrollbar,
		moment,
	},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			notificationsData : [],
			notes : [],
			version : ''
		}
	},
	computed: {
		...authComputed,
	},
	methods: {
		viewNotif(data) {
	        axios({
	          method: 'post',
	          url: 'notification/read',
	          data: [data.id]
	        }).then(response => {
	         this.loadEntries();
	        }, error => {
	        });

	      	this.$swal({
		        html: data.content,
		        align: 'left',
		        showConfirmButton: false,
		        showCloseButton: false,
		        showCancelButton: true,
		        cancelButtonText: 'Kembali',
	      	});

	      	this.$swal({
		        html: data.content,
		        align: 'left',
		        showConfirmButton: false,
		        showCloseButton: false,
		        showCancelButton: true,
		        cancelButtonText: 'Kembali',
	      	});
		},
		loadNotif() {
			this.getNotifications();
		},
		toggleMenu() {
			this.$parent.toggleMenu()
		},
		getNotifications() {

	        axios({
	          method: 'get',
	          url: 'parameter/notes'
	        }).then(response => {
	        	this.notes = response.data.data;
	        	this.version = 'v.'+this.notes.version;

	        	if(!this.notes.isOpened){
			      	this.$swal({
				        html: "<b>Update Terbaru Versi "+this.notes.version+"</b><hr><br>"+this.notes.notes,
				        align: 'center',
				        showConfirmButton: false,
				        showCloseButton: false,
				        showCancelButton: true,
				        cancelButtonText: 'Ok',
			      	});
	        	}

	        }, error => {
	        });

			axios.get('notification/search-unread/0/20')
			.then((response) => {
	        	this.notificationsData = response.data.data.content; 
	      	})
	      	.catch((error) => {
	      	})
		},
	},
  	mounted () {
		this.getNotifications();
  		this.moment = moment;
  	}
}
</script>

<template>
	<!-- Topbar Start -->
	<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">

		<div class="area" style="z-index: -111;">
		<ul class="circles">
		<li></li><li></li><li></li>
		<li></li><li></li><li></li>
		<li></li><li></li><li></li>
		<li></li><li></li><li></li>
		<li></li><li></li><li></li>
		</ul>
		</div >

		<div class="container-fluid">
			<!-- LOGO -->
			<a href="/" class="navbar-brand mr-0 mr-md-2 logo">
				<span class="logo-lg">
					<img src="@assets/images/logo-kejak.png" alt height="34" />
					<span class="d-inline h5 ml-2 text-logo">Pedoman Narkotika {{this.version}}</span>
				</span>
				<span class="logo-sm">
					<img src="@assets/images/logo-kejak.png" alt height="24" />
				</span>
			</a>

			<ul
				class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0"
			>
				<li class>
					<button
						class="button-menu-mobile open-left disable-btn"
						:class="{ open: isMenuOpened }"
						@click="toggleMenu"
					>
						<feather type="menu" class="menu-icon align-middle"></feather>
						<feather type="x" class="close-icon"></feather>
					</button>
				</li>
			</ul>

			<ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
				<b-nav-item-dropdown
				  	@show="loadNotif"
					id="bell-notification"
					right
					variant="white"
					class="notification-list"
					menu-class="dropdown-lg"
				>
					<template v-slot:button-content >
						<feather type="bell" class="align-middle"></feather>
						<!-- <span class="noti-icon-badge"></span> -->
					</template>

					<b-dropdown-text class="noti-title border-bottom pb-2" tag="div">
						<h5 class="m-0 font-size-16">
							Notifikasi Baru
						</h5>
					</b-dropdown-text>

					<VuePerfectScrollbar class="noti-scroll">
						<b-dropdown-text
							href="javascript:void(0);"
							class="notify-item border-bottom"
							v-if="this.notificationsData == null || this.notificationsData.length < 1"
						>
							Belum ada notifikasi
						</b-dropdown-text>

						<b-dropdown-text
							style="cursor:pointer"
							href="javascript:void(0);"
							class="notify-item border-bottom"
							v-for="(data, index) in this.notificationsData"
							@click="viewNotif(data)"
						>
							<b>{{data.title}}</b><br>
							<small class="text-muted">{{moment(data.createdDate).format('DD-MMM-YYYY HH:mm:ss')}}</small>
						</b-dropdown-text>
					</VuePerfectScrollbar>

					<b-dropdown-item class="text-center notify-item p-0">
						<router-link to="/inbox">
							<span>Lihat Semua</span>
						</router-link>
					</b-dropdown-item>
					
				</b-nav-item-dropdown>

				<b-nav-item-dropdown
					right
					class="notification-list align-self-center profile-dropdown"
					toggle-class="nav-user mr-0"
				>
					<template v-slot:button-content>
						<div class="media user-profile">
							<div class="media-body text-left">
								<h6 class="pro-user-name ml-2 my-0" v-if="user != null">
									<span>{{ user.profile.name }}</span>
									<span class="pro-user-desc text-muted d-block mt-1">{{ user.profile.role }}</span>
								</h6>
							</div>
							<feather
								type="chevron-down"
								class="ml-2 align-self-center"
							></feather>
						</div>
					</template>

					<b-dropdown-item href="/profile" class="notify-item p-0">
						<feather type="user" class="icon-dual icon-xs mr-2"></feather>
						<span>Profil Anda</span>
					</b-dropdown-item>

					<b-dropdown-divider></b-dropdown-divider>

					<b-dropdown-item href="/logout" class="notify-item p-0">
						<feather type="log-out" class="icon-dual icon-xs mr-2"></feather>
						<span>Keluar</span>
					</b-dropdown-item>
				</b-nav-item-dropdown>
			</ul>
		</div>
	</div>
	<!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
	height: 220px;
}
.ps > .ps__scrollbar-y-rail {
	width: 8px !important;
	background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
	width: 6px !important;
}
.button-menu-mobile {
	outline: none !important;
}
.text-logo{
    text-transform: none;
    font-weight:bold;
}
@media (min-width: 992px){
	.topbar-nav .metismenu li:nth-child(2) a{
		padding-left:1rem;
	}
}


.circles{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.circles li{
    position: absolute;
    display: block;
    list-style: none;
    width: 20px;
    height: 20px;
    background: #ececec;
    animation: animate 25s linear infinite;
    bottom: -150px;
    z-index:-1;
}

.circles li:nth-child(1){
    left: 25%;
    width: 45px;
    height: 45px;
    animation-delay: 0s;
}

.circles li:nth-child(2){
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;
}

.circles li:nth-child(3){
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;
}

.circles li:nth-child(4){
    left: 40%;
    width: 33px;
    height: 33px;
    animation-delay: 0s;
    animation-duration: 18s;
}

.circles li:nth-child(5){
    left: 65%;
    width: 20px;
    height: 20px;
    animation-delay: 0s;
}

.circles li:nth-child(6){
    left: 75%;
    width: 54px;
    height: 54px;
    animation-delay: 4s;
}

.circles li:nth-child(7){
    left: 35%;
    width: 27px;
    height: 27px;
    animation-delay: 7s;
}

.circles li:nth-child(8){
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;
}

.circles li:nth-child(9){
    left: 20%;
    width: 19px;
    height: 19px;
    animation-delay: 2s;
    animation-duration: 35s;
}

.circles li:nth-child(10){
    left: 85%;
    width: 36px;
    height: 36px;
    animation-delay: 0s;
    animation-duration: 11s;
}
.circles li:nth-child(11){
    left: 27%;
    width: 31px;
    height: 31px;
    animation-delay: 0s;
    animation-duration: 21s;
}
.circles li:nth-child(12){
    left: 15%;
    width: 22px;
    height: 22px;
    animation-delay: 0s;
    animation-duration: 11s;
}
.circles li:nth-child(13){
    left: 55%;
    width: 42px;
    height: 42px;
    animation-delay: 0s;
    animation-duration: 18s;
}
.circles li:nth-child(14){
    left: 45%;
    width: 32px;
    height: 32px;
    animation-delay: 0s;
    animation-duration: 20s;
}
.circles li:nth-child(15){
    left: 76%;
    width: 29px;
    height: 29px;
    animation-delay: 0s;
    animation-duration: 9s;
}

@keyframes animate {
    0%{
        transform: translateY(0) rotate(0deg);
        opacity: 1;
        border-radius: 0;
    }

    100%{
        transform: translateY(-1000px) rotate(720deg);
        opacity: 0;
        border-radius: 50%;
    }
}
</style>
